import React, { useEffect } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, FormFeedback, Label, Button } from 'reactstrap'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

// Only allow letters, numbers, spaces, dot, dash, underscore, comma, apostrophe
const reasonRegex = /^[a-zA-Z0-9\s.,\-_']*$/

const schema = yup.object().shape({
    reason: yup
        .string()
        .trim()
        .required('Reason is required.')
        .matches(reasonRegex, 'Only letters, numbers, spaces, dot, dash, underscore, apostrophe, and comma are allowed.'),
})

const SubroClaimReasonModal = ({ isOpen, isSubmitting, onCancel, onContinue }) => {
    const { control, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange',
    })

    useEffect(() => {
        if (!isOpen) {
            reset()
        }
    }, [isOpen, reset])

    if (!isOpen) {
        return null
    }

    const onSubmit = (formData) => {
        onContinue(formData.reason.trim())
    }

    return (
        <Modal isOpen={isOpen} toggle={onCancel}>
            <ModalHeader>Reason for Subro Claim Change</ModalHeader>
            <form onSubmit={handleSubmit(onSubmit)}>
                <ModalBody>
                    <FormGroup>
                        <Label for="subroClaimReason">
                            Please provide a reason for changing "Has Subro Claim?" to No:
                        </Label>
                        <Controller
                            name="reason"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value } }) => (
                                <Input
                                    id="subroClaimReason"
                                    type="textarea"
                                    value={value}
                                    onChange={onChange}
                                    invalid={!!errors.reason}
                                    placeholder="Enter reason..."
                                    autoFocus
                                />
                            )}
                        />
                        {errors.reason && (
                            <FormFeedback>{errors.reason.message}</FormFeedback>
                        )}
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={onCancel} type="button" disabled={isSubmitting}>Cancel</Button>
                    <Button color="warning" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? "Saving..." : "Continue"}
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    )
}

export default SubroClaimReasonModal
